import $ from 'jquery';

import { FireComponent, FireHelpers } from '@base';

export class Search extends FireComponent {
  constructor(id) {
    super(id);
  }

  _searchTerm() {
    var inputTerm = $('[data-drupal-selector="edit-keyword"]').val();
    var paramTermFull = window.location.search;
    var paramTerm = paramTermFull.replace('?keyword=', '');

    if (inputTerm) {
      $('[data-searched-item], .bux-search__no-results > span').text(inputTerm);
    } else if (paramTerm) {
      $('[data-searched-item], .bux-search__no-results > span').text(paramTerm);
    } else {
      $('.bux-search__header').addClass('hidden');
    }
  }

  init() {
    if (!this.componentExists) return;

    this._searchTerm();

    $(document).ajaxComplete(() => {
      this._searchTerm();
    });
  }
}
